import { SETSHORTCODE } from '../types';

const setShortCode = ShortCode => ({ type: SETSHORTCODE, ShortCode });

export { setShortCode };
